import React from "react";
import CardComponent from "../components/CardComponent";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  displayCardDiv: {
    // minWidth: 275,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
  },
});

const DisplayCard = () => {
  const classes = useStyles();

  return (
    <div className={classes.displayCardDiv}>
      <CardComponent
        title="Hospital List"
        details="List of the hospitals near you"
      />
      <CardComponent
        title="Patient Tracker"
        details="Tracking of the Covid Patient"
      />
      <CardComponent
        title="Vaccination"
        details="Get all the Vaccination details"
      />
    </div>
  );
};

export default DisplayCard;
